export default __webpack_public_path__ + "static/media/7A1_2006-339_rodak-weaver_scan1.3af72532.png";